<template>
  <section class="section-block">
    <SectionTitle title="會員中心連結" btn="更新連結" :hideBtn="!enableLiff" @edit="createLiff('appointment')" />
    <BaseElForm>
      <BaseElFormItem label="會員中心">
        <div class="copy-block">
          <a :href="profileUrl">
            {{ profileUrl || '尚未設定，請聯繫客服' }}
          </a>
          <div>
            <BaseElButton
              :disabled="!profileUrl"
              class="copy-btn"
              type="primary"
              :class="{ disable: !profileUrl }"
              @click.prevent="copyLink(profileUrl)"
            >
              複製
            </BaseElButton>
          </div>
        </div>
      </BaseElFormItem>
    </BaseElForm>
  </section>
</template>

<script>
import SectionTitle from '@/components/Title/SectionTitle'
import copy from 'clipboard-copy'
import { CreateLiff } from '@/api/shop'
import { useShop } from '@/use/shop'
import { GetClientPageConfigLink, GetClientPageConfig } from '@/api/member/memberCenter'
import { defineComponent, onMounted, ref, computed } from 'vue'
import { get, find } from 'lodash'

export default defineComponent({
  name: 'MemberCenterLink',
  components: {
    SectionTitle,
  },
  props: ['liff'],
  setup (props, { emit }) {
    const { shopId } = useShop()
    const enableLiff = ref(false)
    const link = ref({})
    const profileUrl = computed(() => {
      if (enableLiff.value) { // 舊制
        if (!liffLink('appointment')) return false
        return `${liffLink('appointment').liffUrl}/profile`
      } else return get(link.value, 'memberCenter') // 新制
    })

    const getClientPageConfig = async () => {
      const [res, err] = await GetClientPageConfig({ shopId: shopId.value })
      if (err) {
        window.$message.error(err)
        return
      }
      enableLiff.value = get(res, 'enableLiff', true)
    }
    const getClientPageConfigLink = async () => {
      const [res, err] = await GetClientPageConfigLink({ shopId: shopId.value })
      if (err) {
        window.$message.error(err)
        return
      }
      link.value = res
    }
    const copyLink = (link) => {
      copy(link)
      window.$message.success('已成功複製連結！')
    }
    const liffLink = (name) => {
      if (!props.liff) return false
      return find(props.liff, (item) => item.name === name)
    }

    const createLiff = async (name) => {
      try {
        await CreateLiff({ shopId: shopId.value, name })
        emit('refresh')
        window.$message.success('更新 Liff 連結成功!')
      } catch (error) {
        console.log(error)
        window.$message.error(error)
      }
    }
    onMounted(async () => {
      await Promise.allSettled([
        getClientPageConfig(),
        getClientPageConfigLink(),
      ])
    })
    return {
      enableLiff,
      copyLink,
      liffLink,
      createLiff,
      profileUrl,
    }
  },
})
</script>

<style lang="postcss" scoped>
.copy-block {
  @apply flex items-center;
}
.copy-btn {
  @apply h-[30px] rounded-full py-[3px] ml-[30px] px-[30px];
}
</style>
